import React from 'react';
import { NumericalColumn, CustomColumn } from 'baseui/data-table';
import _isEmpty from 'lodash/isEmpty';
import _startsWith from 'lodash/startsWith';
import { Button, KIND } from 'baseui/button';
import { StyledLink } from 'baseui/link';

import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	rank: 'rank',
	zupeeUserId: 'zupeeUserId',
	ltid: 'ltid',
	gamename: 'gamename'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Rank',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.rank] || 0
	}),
	CustomColumn({
		title: 'Zupee User Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			return {
				zupeeUserId: (data[COL_NAMES.zupeeUserId] || EMPTY_STRING).toString(),
				gameName: data[COL_NAMES.gamename],
				ltid: data[COL_NAMES.ltid]
			};
		},
		renderCell: (params: any) => {
			const { value } = params;

			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				if (_isEmpty(value)) return;
				const url = `/userProfile/gameplay/details?uid=${value.zupeeUserId}&ltid=${value?.ltid}&gameName=${value?.gameName}`;
				window.open(url, '_blank');
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{value.zupeeUserId}</StyledLink>
				</Button>
			);
		},
		textQueryFilter: (textQuery: String, data: any): boolean => {
			return _startsWith(data, `${textQuery}`);
		}
	})
];
